export default __webpack_public_path__ + "static/media/img-3788.85dfd250.jpeg";